//活动状态
const titleList = [
    {id: 0, name: '活动介绍'},  //0
    {id: 1, name: '我的视频'},  //1
    {id: 2, name: '视频投票'},  //2
    {id: 3, name: '初赛投票'},  //3
    {id: 4, name: '决赛投票'},  //4
    {id: 5, name: '获奖名单'},  //5
]

// 科普活动
// 有一轮投票--各阶段说明
// 0. 未开放、其它渠道看到的活动详情
// 1. 报名/上传/投票
// 2. 获奖公布

// 有二轮投票--各阶段说明
// 0. 未开放、其它渠道看到的活动详情
// 1. 报名/上传/初赛投票
// 2. 决赛投票
// 3. 获奖公布

// 有一轮投票--各阶段说明
// 0. 未开放、其它渠道看到的活动详情
const n1_waitStart = [0]
// 1. 报名/上传/投票
const n1_signUp_no = [0,2]
const n1_signUp_yes = [1,2,0]
// 2. 获奖公布
const n1_end_no = [5,2,0]
const n1_end_yes = [1,5,2,0]

// 有二轮投票--各阶段说明
// 0. 未开放、其它渠道看到的活动详情
const n2_waitStart = [0]
// 1. 报名/上传/初赛投票
const n2_signUp_no = [0,3]
const n2_signUp_yes = [1,3,0]
// 2. 决赛投票
const n2_final_no = [4,0]
const n2_final_yes = [1,4,0]
// 3. 获奖公布
const n2_end_no = [5,4,0]
const n2_end_yes = [1,5,4,0]



//step： 活动正在进行的阶段
//isSignUp： 是否已经参赛：
//howToMatch: 比赛方式
export function getActTitles(step, isSignUp, howToMatch=1){
    let retList = [];
    let tmpIndex;
    //未报名
    tmpIndex = getTabControlID(step, isSignUp, howToMatch)

    tmpIndex.forEach( (item, index)=>{
        retList.push(titleList[item])
        }
    )

    return retList
}

function getMatch1(step, isSignUp){
    let tmpIndex;
    //未报名
    if(isSignUp == 0){
        switch (step){
            case 0:
            default:
                tmpIndex = n1_waitStart;
                break;
            case 1:
                tmpIndex = n1_signUp_no;
                break;
            case 2:
                tmpIndex = n1_end_no;
                break;
        }
    }
    //已经报名
    else{
        switch (step){
            case 0:
            default:
                tmpIndex = n1_waitStart;
                break;
            case 1:
                tmpIndex = n1_signUp_yes;
                break;
            case 2:
                tmpIndex = n1_end_yes;
                break;
        }
    }

    return tmpIndex
}
function getMatch2(step, isSignUp){
    let tmpIndex;
    //未报名
    if(isSignUp == 0){
        switch (step){
            case 0:
            default:
                tmpIndex = n2_waitStart;
                break;
            case 1:
                tmpIndex = n2_signUp_no;
                break;
            case 2:
                tmpIndex = n2_final_no;
                break;
            case 3:
                tmpIndex = n2_end_no;
                break;
        }
    }
    //已经报名
    else{
        switch (step){
            case 0:
            default:
                tmpIndex = n2_waitStart;
                break;
            case 1:
                tmpIndex = n2_signUp_yes;
                break;
            case 2:
                tmpIndex = n2_final_yes;
                break;
            case 3:
                tmpIndex = n2_end_yes;
                break;
        }
    }
    return tmpIndex
}
function getTabControlID(step, isSignUp, howToMatch){
    switch (howToMatch){
        case 1:
            return getMatch1(step, isSignUp)
            break;
        case 2:
            return getMatch2(step, isSignUp)
            break;
        default:
            return getMatch2(step, isSignUp)
            break;
    }
}